import { getStreetName } from "./getStreetName";
import { getStreetNumber } from "./getStreetNumber";

export const compareAddresses = (a: string, b: string): number => {
  const streetNameA = getStreetName(a);
  const streetNameB = getStreetName(b);
  const streetNumberA = getStreetNumber(a);
  const streetNumberB = getStreetNumber(b);

  if (streetNameA === streetNameB) {
    // If street names are the same, compare street numbers
    if (streetNumberA === streetNumberB) {
      return 0;
    }
    if (streetNumberA === null || streetNumberA === undefined) return 1;
    if (streetNumberB === null || streetNumberB === undefined) return -1;
    return streetNumberA.localeCompare(streetNumberB, undefined, {
      numeric: true,
    });
  }

  if (streetNameA === null || streetNameA === undefined) return 1;
  if (streetNameB === null || streetNameB === undefined) return -1;
  return streetNameA.localeCompare(streetNameB);
};

export function sortByAddress<T>(
  list: T[],
  keyExtractor?: (obj: T) => string
): T[] {
  return [...list].sort((a, b) => {
    const addressA = keyExtractor ? keyExtractor(a) : (a as string);
    const addressB = keyExtractor ? keyExtractor(b) : (b as string);
    return compareAddresses(addressA, addressB);
  });
}
